var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottombarLessons = function SvgBottombarLessons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.86v-3.344c0-3.306 0-4.96 1.06-5.523 1.06-.565 2.432.359 5.174 2.206l2.602 1.751c2.325 1.567 3.488 2.35 3.464 3.442s-1.22 1.824-3.61 3.288l-2.601 1.592c-2.696 1.65-4.044 2.476-5.067 1.903C7 18.602 7 17.022 7 13.861"
  })));
};
export default SvgBottombarLessons;